module.exports = __webpack_public_path__ + "static/media/3.e50ce727.jpg";